import React, { useState, useEffect } from "react";
import styles from "./AskApollo.module.scss";
import axios from "axios";
import { clientRoutes } from "helpers/clientRoutes";
import { useRouter } from "next/router";
import { eventTracking } from "clevertapTracking";
import { utmEventDetails } from "helpers/commonHelpers";
import { useAuth } from "hooks/authHooks";
import useMobileDetect from "helpers/useMobileDetect";
import { SignedinState } from "components/enums/SignedinState";
import Link from "next/link";
import Lottie from "react-lottie";
import { defaultAnimationProps } from "components/SymptomChecker/SymptomCheckerHelper";
import { ParsedDeviceCharacterstics } from "components/interfaces/ParsedDeviceCharacterstics";
interface AskApolloProps {
  placement?: string;
  staticContentInfo?: any;
  isOnWeb?: boolean;
  isOnMweb?: boolean;
  ua?: ParsedDeviceCharacterstics;
}

export const SymptomChecker: React.FC<AskApolloProps> = (props) => {
  const { ua, placement, staticContentInfo } = props;
  const router = useRouter();
  const [loading, setloading] = useState<boolean>(false);
  const { isSignedIn } = useAuth();
  const { currentPatient } = useAuth();
  const currentDevice = useMobileDetect();
  const [animationData, setAnimationData] = useState<any>(null);

  const handleSource = () => {
    const currentPath = router.asPath;
    if (currentPath === clientRoutes.specialityListing()) {
      return "specialtyPage";
    } else {
      return "homePage";
    }
  };

  const triggerEvent = (isPrimary?: boolean, symName?: string) => {
    let eventData = {
      ...utmEventDetails(),
      "Type of user":
        isSignedIn === SignedinState.SIGNEDIN ? "Logged-in" : "non-logged-in",
      "Phone Number": currentPatient?.mobileNumber || "NA",
      Platform: currentDevice.isDesktop() ? "Web" : "mWeb",
      URL: router.asPath || "",
      "Screen name": handleSource(),
      "Option Selected": isPrimary ? "Primary CTA" : "Symptoms",
      "Symptom Selected": symName || "NA",
    };
    eventTracking("Symptom Checker Clicked", eventData);
  };

  useEffect(() => {
    getAnimatedLogo();
  }, []);

  const getAnimatedLogo = () => {
    axios
      .get(
        `${process.env.NEXT_PUBLIC_247_CDN_URL}/images/askApollo/animation/animation_mascot_slow.json`
      )
      .then((res: any) => {
        if (res?.data) {
          setAnimationData({ mascot_slow: res?.data });
        }
      })
      .catch((error) => {
        console.error(error?.message);
      });
  };

  const getRedirectUrl = (item: any) => {
    return `${clientRoutes.symptomChecker()}?symptomId=${
      item?.id
    }&symptomName=${item?.name}&source=${handleSource()}`;
  };

  useEffect(() => {
    const html = document.querySelectorAll('[class*="lottieContainer"]')[0];
    const svgElement = html?.getElementsByTagName("svg");
    if (svgElement) {
      setTimeout(() => {
        svgElement[0].setAttribute("aria-label", "Ask Apollo");
        svgElement[0].setAttribute("role", "presentation");
      }, 5000);
    }
  }, []);

  const getSymptomOptions = () => {
    let processImages =
      placement?.length > 0 && currentDevice.isDesktop()
        ? props?.staticContentInfo?.entryPointsWithoutSymptoms
            ?.images_web_specialty
        : props?.staticContentInfo?.entryPointsWithoutSymptoms?.images_web ||
          [];
    return (
      <>
        {props?.staticContentInfo?.entryPoints?.tobeShown &&
        !props?.staticContentInfo?.entryPointsWithoutSymptoms?.tobeShown ? (
          <div
            className={`${styles.askApolloContainer} ${
              placement ? styles[placement] : ""
            }`}
          >
            <div className={styles.askApolloContent}>
              <div className={styles.lottieContainer}>
                <Lottie
                  options={defaultAnimationProps(animationData?.mascot_slow)}
                  height={80}
                  width={95}
                />
              </div>
              {/* <h2>{props?.staticContentInfo?.entryPoints?.header || ""}</h2> */}
              <p>{props?.staticContentInfo?.entryPoints?.subText || ""}</p>
            </div>
            <div className={styles.symptomContainer}>
              {props?.staticContentInfo?.entryPoints?.symptoms?.length > 0 && (
                <ul className={styles.symptomList}>
                  {props?.staticContentInfo?.entryPoints?.symptoms?.map(
                    (symp: any, i: number) => {
                      return (
                        <li key={i}>
                          <Link href={getRedirectUrl(symp)}>
                            <a>
                              <div className={styles.symptomCard}>
                                <img
                                  src={`${symp?.image}`}
                                  alt={symp?.name || ""}
                                />
                                <p> {symp?.name || ""}</p>
                              </div>
                            </a>
                          </Link>
                          <div
                            className={styles.symptomCard}
                            onClick={() => {
                              triggerEvent(false, symp?.name || "");
                              window.location.href = getRedirectUrl(symp);
                            }}
                          >
                            <img
                              src={`${symp?.image}`}
                              alt={symp?.name || ""}
                            />
                            <p> {symp?.name || ""}</p>
                          </div>
                        </li>
                      );
                    }
                  )}
                </ul>
              )}
              <div
                className={styles.otherSymptom}
                onClick={() => {
                  triggerEvent(true);
                  window.location.href = `${clientRoutes.symptomChecker()}?source=${handleSource()}`;
                }}
              >
                <p>{props?.staticContentInfo?.entryPoints?.helperText || ""}</p>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        {props?.staticContentInfo?.entryPointsWithoutSymptoms?.tobeShown &&
        !props?.staticContentInfo?.entryPoints?.tobeShown ? (
          <div
            className={`${styles.askApolloCustomizedScreen} ${
              placement ? styles[placement] : ""
            }`}
          >
            <div className={styles.descWrap}>
              <span className={styles.imgWrap}>
                <Lottie
                  options={defaultAnimationProps(animationData?.mascot_slow)}
                  height={80}
                  width={95}
                />
              </span>
              <p>
                <span>
                  {props?.staticContentInfo?.entryPointsWithoutSymptoms
                    ?.header || ""}
                </span>{" "}
                {placement?.length > 0
                  ? props?.staticContentInfo?.entryPointsWithoutSymptoms
                      ?.entryPointsConsultHomeScreen
                  : props?.staticContentInfo?.entryPointsWithoutSymptoms
                      ?.entryPointsConsultOtherScreens || ""}
              </p>
            </div>
            <div className={styles.symptomListContainer}>
              {processImages?.length &&
                processImages?.map((symp: any, i: number) => {
                  return (
                    <>
                      <div key={i} className={styles.symptomCardContainer}>
                        <img src={`${symp}`} alt={symp || ""} />
                      </div>
                      <span className={styles.arrow}></span>
                    </>
                  );
                })}
            </div>
            <button
              onClick={() => {
                triggerEvent(true);
                window.location.href = `${clientRoutes.symptomChecker()}?source=${handleSource()}`;
              }}
            >
              {`${props?.staticContentInfo?.entryPointsWithoutSymptoms?.helperText} ` ||
                ""}{" "}
              <span className={`${styles.rightArrow} icon-ic_arrow_right2`} />
            </button>
          </div>
        ) : (
          ""
        )}
      </>
    );
  };

  return (
    <>
      {props?.isOnMweb && ua.isMobile && <>{getSymptomOptions()}</>}
      {props?.isOnWeb && ua.isDesktop && <>{getSymptomOptions()}</>}
    </>
  );
};
